import { IconBase } from './IconBase'

type IconRightProps = React.ComponentProps<'svg'>

export const IconRight = (props: IconRightProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.524 12.445a1.33 1.33 0 0 1-.268.383l-9.428 9.428a1.333 1.333 0 0 1-1.885-1.885l8.642-8.642L6.057 3.2a1.333 1.333 0 1 1 1.885-1.886l9.428 9.428c.463.464.515 1.182.154 1.702Z"
      />
    </IconBase>
  )
}
